
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import YetkiliBilgiSection from "../../load/mainSections/YetkiliBilgiSection"
import Btn from "../../shared/button/Btn"
import { updateRouteData } from "../../../features/loadList/loadListSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            width: 100%;
            display: flex;
            height: 600px;
            padding: 40px;
            overflow-x: auto;

            .input-side{
                width: 50%;
                min-height: 400px;
                background-color: rebeccapurple;
            }

            .map-side{

            }
        
        }

        .btn-container{
            width: 100%;
            height: 70px;
            margin: 0 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 40px;
            border-top: 1px solid ${({theme}) => theme.mainBorderColor};
        }
    }
`

const LoadYetkiliBilgiFormModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const { loadItemData } = useSelector(state => state.loadList)

    const [routeData, setRouteData] = useState(loadItemData.routePoints.$values)
 
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    const handleSubmit = () => {

        const updatedList = routeData.map((item) => {
            const { loadMethods, routePointPersonPhoneNumber, ...otherData} = item
            return {...otherData, routePointPersonPhoneNumber: (routePointPersonPhoneNumber?.startsWith("+90") || routePointPersonPhoneNumber?.startsWith("90")) ? routePointPersonPhoneNumber?.slice(2) : routePointPersonPhoneNumber,  waitinLoadId: loadItemData.id}
        })
        
        dispatch(updateRouteData(updatedList))
    }

  return (
    <Container>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <PageTopTitle title={"Yetkili Bilgileri"}/>
            <div className="content">
                <YetkiliBilgiSection data={routeData} setData={setRouteData}/>
            </div>
            <div className="btn-container">
                <Btn bgColor="#E85446" color="#fff" borderColor="transparent" width={"220px"} handleClick={handleSubmit}>Kaydet</Btn>
                <Btn bgColor="#E85446" color="#fff" borderColor="transparent" width={"220px"} handleClick={() => dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
        </div>
    </Container>
  )
}

export default LoadYetkiliBilgiFormModal